import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import TextField from "@mui/material/TextField";
import {  SetCreateAttendanceRegularizationEmpAction , setEmpAttendanceEmpEmpAction , setEmpClientBranchListEmpEmpAction ,setEmpsiteTransferGetlistCreateEmpEmpAction ,

    setEmsiteTransferEmployeedatasEmpEmpAction
} from "../../../Redux/Slice";
import dayjs from 'dayjs';
import Select from "react-select";

function SiteTransferPOpupForEmp(props) {
    const {
        show,
        setShow,
        editPayload,
        refresh,
        selectedPerformanceId,
        setEditPayload,
        PageIndex,
        status,
        search
    } = props;
    const [grading_name, setGrading_name] = useState("");
    const [total_points, setTotal_points] = useState("");
    const [value, setValue] = useState();
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

    const userId = useSelector(
        (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
    );
    const [data, setData] = useState({
        request_type: "request",
        reason: "",
        user_id: "",
        from_client: "",
        to_client: "",
        joining_date:"",
        end_date:""
    });
    const [fieldErrors, setFieldErrors] = useState({
        reason: "",
        user_id: "",
        from_client: "",
        to_client: "",
        joining_date:"",
        end_date:""

    });
    const [editMode, setEditMode] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const dispatch = useDispatch();
    const state = useSelector((state)=>state);
    const [EmployeeOptions ,setEmployeeOptions] = useState([]);
    const [EmployeeValues , setEmployeeValues] = useState()
    const [searchfiled , setsearchfield] = useState({
        EmpSearch:"",
        ToclientSearch:""
    })
const [FromClientValues , setFromClientValues] = useState([]);
 const [ToClientOption , setToClientOptions] = useState([])
 const [ToclientValue , setToClientValues] = useState([])

    const handleError = () => {
        const newFieldErrors = {};
        Object.entries(data).forEach(([key, value]) => {
            if (key === "joining_date" && value.length === 0) {
                newFieldErrors[key] = "Date must not be empty.";
            } else if (key === "reason" && value.length === 0) {
                newFieldErrors[key] = "Reason must not be empty.";
            } else if (key === "end_date" && value.length === 0) {
                newFieldErrors[key] = "Date must not be empty.";
            } else if (key === "user_id" && value.length === 0) {
                newFieldErrors[key] = "Employee must not be empty.";
            }  else if (key === "to_client" && value.length === 0) {
                newFieldErrors[key] = "Client information must not be empty.";
            }
            
            else {
                newFieldErrors[key] = "";
            }
        });
        const hasError = Object.values(newFieldErrors).some((error) => error);
        setFieldErrors(newFieldErrors);
        if (!hasError) {
const payload ={
    data:data,
    PageIndex:PageIndex,
    search:search
}
            dispatch(setEmpsiteTransferGetlistCreateEmpEmpAction(payload));

            setEditPayload("");
            setData({
                for_date: "",
                notes: "",
                from_time: "",
                to_time: "",
                user_id: "",
            });
            setFieldErrors({
                for_date: "",
                notes: "",
                from_time: "",
                to_time: "",
            });
            setShow(false);
        }
    };
    const handleSubmit = () => {
        handleError();

    };
    useEffect(() => {
        if (Object.keys(editPayload).length > 0) {
            setEditMode(true);
            setGrading_name(editPayload.grading_name);
            setTotal_points(editPayload.total_points);
        }
    }, [editPayload]);
    const handleClose = () => {
        setEditPayload("");
        setShow(false);
    };

    useEffect(() => { 
        const payload = {
            page_size: 20,
            page: 1,
            search: searchfiled.EmpSearch,
            // all: true
        };
        dispatch(setEmsiteTransferEmployeedatasEmpEmpAction(payload));
    }, [searchfiled.EmpSearch]);
     useEffect(()=>{
         const payload ={
            page: 1,
            search: searchfiled.ToclientSearch,
            page_size:20

         }
         dispatch(setEmpClientBranchListEmpEmpAction(payload))
     },[searchfiled.ToclientSearch])
     useEffect(()=>{
        let objectArray = []
       state.EmployeeClientBranchForEmpData.ClientBranchDataForEmployee.forEach(element => {
           if(data.from_client != element.id){ 
           objectArray.push({
               value: element.id,
               label: element.client_name.toUpperCase(),
             });
            }
       });
       setToClientOptions(objectArray)
   },[state.EmployeeClientBranchForEmpData.ClientBranchDataForEmployee , searchfiled.ToclientSearch , data.from_client])
 

useEffect(()=>{
     let objectArray = []
     state.sitetransferemployeeapidata.sitetransferempdatalistempsite.forEach(element => {
        console.log(element ,"asodupaosd element.user_id", 
            element.client_id.client_name
        );
        
        // if(element.user_id.user_role.white_collar == false){ 
        objectArray.push({
            value: element.user_id.id,
            label: element.user_id.first_name.toUpperCase(),
            clientId:element.client_id.id,
            clientname:element.client_id.client_name
                        

          });
        // }
    });
    setEmployeeOptions(objectArray)
     
},[state.sitetransferemployeeapidata.sitetransferempdatalistempsite ,searchfiled.EmpSearch ])


console.log(state.sitetransferemployeeapidata.sitetransferempdatalistempsite ,"asdius sitetransferemployeeapidata",EmployeeOptions);


console.log(EmployeeOptions ,"asd EmployeeOptions");

 const handleChangeEmp =(e)=>{
    setEmployeeValues(e)
    
    setData({
        ...data,
        user_id:e.value,
        from_client:e.clientId,
    })
    setFieldErrors((prev) => ({
        ...prev,
        user_id: "",
      }));
    setFromClientValues({value:e.clientId,label:e.clientname})
 } 
  const handleChangeToClient =(val)=>{
    setData({
        ...data,
        to_client:val.value,
    })
    setFieldErrors((prev) => ({
        ...prev,
        to_client: "",
      }));
    setToClientValues(val);
  }
 const handleInputChangeEMP =(e)=>{
    setsearchfield({
        ...searchfiled,
        EmpSearch:e
    })
 }
  const handleInputChangeToClient = (e)=>{
    setsearchfield({
        ...searchfiled,
        ToclientSearch:e
    })
  }
    const formatDate = (inputDate) => {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const formatDateToHHMM = (dateString) => {
        const date = new Date(dateString);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
    };
    const handleDate = (inputDate, name) => {
        setFieldErrors((prev) => {
            return {
                ...prev,
                [name]: "",
            };
        });
        const value = formatDate(inputDate);
        setData((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
            className="modelman"
            size="lg"
            backdrop="static"
        >
            <Modal.Header className="popHead">
                <Modal.Title>
                    {Object.entries(editPayload).length > 0
                        ? "Site Transfer Request"
                        : "Site Transfer Request"}
                </Modal.Title>
                <div className="CloseIcon" onClick={handleClose}>
                    <CloseOutlinedIcon />
                </div>
            </Modal.Header>
            <Modal.Body>

                <div className="row">
                <div className="col-12">
                        <label
                            htmlFor="to_date"
                        >
                            Employee
                            <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            options={EmployeeOptions}
                            onChange={handleChangeEmp}
                            onInputChange={handleInputChangeEMP}
                            labelledBy="Select"
                        />

{fieldErrors.user_id && (
                                <div
                                    className="error"
                                    style={{
                                        color: "red",
                                        height: "20px",
                                        padding: "5px",
                                    }}
                                >
                                    {fieldErrors.user_id}
                                    <span style={{ color: "red" }}>*</span>
                                </div>
                            )}          
                    </div>

                </div>

                <div className="row" style={{marginTop:"12px"}}>
                    <div className="col-6">
                        <label
                            htmlFor="to_date"
                        >
                            From
                            <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            // options={EmpOtions}
                            // onChange={handleChange}
                            // onInputChange={handleInputChange}
                            labelledBy="Select"
                            value={FromClientValues}
                            isDisabled
                        />
                    </div>



                    <div className="col-6">
                        <label
                            className="col-12 p-0"
                            htmlFor="to_date"
                        >
                            To
                            <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            options={ToClientOption}
                            onChange={handleChangeToClient}
                            onInputChange={handleInputChangeToClient}
                            value={ToclientValue}
                            labelledBy="Select"
                        />

{fieldErrors.to_client && (
                                <div
                                    className="error"
                                    style={{
                                        color: "red",
                                        height: "20px",
                                        padding: "5px",
                                    }}
                                >
                                    {fieldErrors.to_client}
                                    <span style={{ color: "red" }}>*</span>
                                </div>
                            )}          
                                      </div>

                    <div className="col-6" style={{marginTop:"12px"}}>
                        <label className="col-12 p-0" htmlFor="leaveDate">
                            From <span style={{ color: "red" }}>*</span>
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                style={{ width: "100%" }}
                                onChange={(e) => {
                                    handleDate(e?.$d, "joining_date");
                                }}
                                // shouldDisableDate={(date) => {
                                //     // Get today's date
                                //     const today = dayjs();

                                //     // Disable future dates (dates after today)
                                //     return date.isAfter(today, 'day');
                                // }}
                                //    shouldDisableDate={(date) => {
                                //         // Get the start and end of the current year
                                //         const startOfYear = dayjs().startOf('year');
                                //         const endOfYear = dayjs().endOf('year');
                                    
                                //         // Disable dates outside the current year
                                //         return date.isBefore(startOfYear, 'day') || date.isAfter(endOfYear, 'day');
                                //     }}

                                shouldDisableDate={(date) => {
                                    const endDate = dayjs(data.end_date); // Assuming `data.end_date` is a valid date
                                    const startOfYear = dayjs().startOf('year');
                                    const endOfYear = dayjs().endOf('year');
                        
                                    // Disable dates outside the current year or after the end_date
                                    return (
                                        date.isBefore(startOfYear, 'day') ||
                                        date.isAfter(endOfYear, 'day') ||
                                        date.isAfter(endDate, 'day') // Disable dates after the end_date
                                    );
                                }}
                        
                            />
                            {fieldErrors.joining_date && (
                                <div
                                    className="error"
                                    style={{
                                        color: "red",
                                        height: "20px",
                                        padding: "5px",
                                    }}
                                >
                                    {fieldErrors.joining_date}
                                    <span style={{ color: "red" }}>*</span>
                                </div>
                            )}
                        </LocalizationProvider>
                    </div>

                    <div className="col-6" style={{marginTop:"12px"}}>
                        <label className="col-12 p-0" htmlFor="leaveDate">
                            To <span style={{ color: "red" }}>*</span>
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                style={{ width: "100%" }}
                                onChange={(e) => {
                                    handleDate(e?.$d, "end_date");
                                }}
                                // shouldDisableDate={(date) => {
                                //     // Get today's date
                                //     const today = dayjs();

                                //     // Disable future dates (dates after today)
                                //     return date.isAfter(today, 'day');
                                // }}
                                // shouldDisableDate={(date) => {
                                //     // Get the start and end of the current year
                                //     const startOfYear = dayjs().startOf('year');
                                //     const endOfYear = dayjs().endOf('year');
                                
                                //     // Disable dates outside the current year
                                //     return date.isBefore(startOfYear, 'day') || date.isAfter(endOfYear, 'day');
                                // }}
                                shouldDisableDate={(date) => {
                                    const joiningDate = dayjs(data.joining_date); // Assuming `data.joining_date` is in a valid format
                                    const startOfYear = dayjs().startOf('year');
                                    const endOfYear = dayjs().endOf('year');
                        
                                    // Disable dates outside the current year or before the joining date
                                    return (
                                        date.isBefore(joiningDate, 'day') ||
                                        date.isBefore(startOfYear, 'day') ||
                                        date.isAfter(endOfYear, 'day')
                                    );
                                }}
                        

                            />
                            {fieldErrors.end_date && (
                                <div
                                    className="error"
                                    style={{
                                        color: "red",
                                        height: "20px",
                                        padding: "5px",
                                    }}
                                >
                                    {fieldErrors.end_date}
                                    <span style={{ color: "red" }}>*</span>
                                </div>
                            )}
                        </LocalizationProvider>

                    </div>

                    <div className="col-12 mt-2">
                        <label
                            htmlFor="leaveDate"
                            style={{ margin: "0" }}
                        >
                            {" "}
                            Purpose<span style={{ color: "red" }}>*</span>
                        </label>
                            <textarea
                                style={{
                                    width: "100%",
                                    height: "200px",
                                    border: "1px solid lightgrey",
                                    padding: "11px"
                                }}
                                value={data.reason}
                                onChange={(e) => {
                                    setFieldErrors((prev) => ({
                                        ...prev,
                                        reason: "",
                                    }));
                                    setData((prev) => ({
                                        ...prev,
                                        reason: e.target.value,
                                    }));
                                }}
                            />
                            {fieldErrors.reason && (
                                <div
                                    className="error"
                                    style={{
                                        color: "red",
                                        height: "20px",
                                        padding: "5px",
                                    }}
                                >
                                    {fieldErrors.reason}
                                    <span style={{ color: "red" }}>*</span>
                                </div>
                            )}
                    </div>

                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className="RoleButton">

                    <button class="btn CancelBtn" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        class="CancelBtn btn"
                        type="submit"
                        onClick={(e) => {
                            handleSubmit();
                        }}
                        style={{ marginBottom: "20px", background: "#234492", color: "white" }}
                    >
                        Submit
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default SiteTransferPOpupForEmp;